
export default {
  props: {
    compact: {type: Boolean, default: false},
    name: {type: String, default: ''},
    size: {type: String, default: '4rem'},
  },
  emits: ['close'],
}
